import {DataTable, Text} from '@/components-v2'
import {InventoryListHeader} from './InventoryListHeader'
import {useInventoryListColumnsV2} from '@/features/InventoryList/useInventoryListColumnsV2'
import {useInventoryListTableV2} from '@/features/InventoryList/useInventoryListTableV2'

const InventoryList = () => {
  const {
    columns,
    tableData,
    pageIndex,
    pageSize,
    totalRowsCount,
    manualPagination,
    manualSorting,
    manualFiltering,
    onPageIndexChange,
    onRowsPerPageChange,
    sortingHandler,
    onColumnFiltersChange,
    resetFilterButtonOptions,
    onTableReady,
    rowSelectionStateUpdater,
    canDownload,
    isDownloading,
    onDownloadClick,
    resetKey,
    formData,
    setFormData,
    downloadInventoryTemplate,
  } = useInventoryListTableV2()

  const transformedColumns = useInventoryListColumnsV2(columns)

  const customHeader = (
    <InventoryListHeader
      resetFilterButtonOptions={resetFilterButtonOptions}
      canDownload={canDownload}
      isDownloading={isDownloading}
      onDownloadClick={onDownloadClick}
      formData={formData}
      setFormData={setFormData}
      downloadInventoryTemplate={downloadInventoryTemplate}
    />
  )

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-[var(--color-background-layer-01)] p-6">
      <Text headingLevel={5}>Inventory list</Text>
      <DataTable
        key={resetKey}
        columns={transformedColumns}
        data={tableData}
        pageIndex={pageIndex}
        pageSize={pageSize}
        totalRowsCount={totalRowsCount}
        onPageIndexChange={onPageIndexChange}
        onRowsPerPageChange={onRowsPerPageChange}
        manualPagination={manualPagination}
        manualSorting={manualSorting}
        manualFiltering={manualFiltering}
        sortingHandler={sortingHandler}
        onColumnFiltersChange={onColumnFiltersChange}
        resetFilterButtonOptions={resetFilterButtonOptions}
        selection="multiple"
        onTableReady={onTableReady}
        rowSelectionStateUpdater={rowSelectionStateUpdater}
        showTableHeader={false}
        customHeader={customHeader}
      />
    </div>
  )
}

export default InventoryList
